import React, { useState, useEffect, useRef, useCallback } from 'react';
import './StickyFooterCTA.css';

const StickyFooterCTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastScrollTime = useRef(0);

  const handleScroll = useCallback(() => {
    const now = Date.now();
    // Throttle: max 10 razy na sekundę (co 100ms)
    if (now - lastScrollTime.current < 100) return;
    lastScrollTime.current = now;

    const scrollY = window.scrollY;
    setIsVisible(scrollY > 800);
  }, []);

  useEffect(() => {
    // Passive listener dla lepszej wydajności scrollowania
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="audited-sticky-footer-cta">
      <div className="audited-sticky-content">
        <span className="audited-sticky-text">Gotowy na sukces w matematyce?</span>
        <button className="audited-sticky-button" onClick={scrollToContact}>
          Umow lekcje GRATIS
        </button>
      </div>
    </div>
  );
};

export default StickyFooterCTA;
